import React, { FC } from "react";
import { Cascader } from "antd";
import { useAllFeeEarnerLevelsAndFeeEarnersQuery } from "../hooks";
import { FeeEarner } from "@design-system";

interface Option {
  value: string | number;
  label: string;
  disabled?: boolean;
  children?: Option[];
}

type FilterFunc = ((inputValue: string, options: any[]) => boolean) | undefined;

type Props = Omit<any, "options"> & { defaultFeeEarner?: FeeEarner | null };

const shouldUseDefaultNameRender = (
  defaultFeeEarner: FeeEarner | null | undefined,
  value: (string | number)[] | undefined,
  label: string[],
  selectedOptions: any[] | undefined
): defaultFeeEarner is FeeEarner =>
  !!defaultFeeEarner &&
  value?.length === 2 &&
  label.length < 2 &&
  !!selectedOptions &&
  selectedOptions[0].value === defaultFeeEarner.feeEarnerLevel?.id.toString();

export const FeeEarnerCascaderContainer: FC<Props> = ({ defaultFeeEarner, value }) => {
  const filter = ((inputValue: string, path: Option[]): boolean => {
    return path.some(
      (option) => option!.label!.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    );
  }) as unknown as FilterFunc;

  const { feeEarnerLevelsAndFeeEarners } = useAllFeeEarnerLevelsAndFeeEarnersQuery(true, false);

  return (
    <Cascader
      showSearch={{ filter }}
      options={feeEarnerLevelsAndFeeEarners}
      displayRender={(label, selectedOptions) => {
        if (shouldUseDefaultNameRender(defaultFeeEarner, value, label, selectedOptions)) {
          return `${label[0]}/${defaultFeeEarner.name}`;
        }
        return label.join("/");
      }}
    />
  );
};
